import { type ISupportedLanguage } from "#app/utils/i18n.tsx";

export class Country {
  static readonly ALBANIA = new Country("AL", {
    en: "Albania",
    it: "Albania",
    de: "Albanien",
    fr: "Albanie",
    es: "Albania",
  });
  static readonly ALGERIA = new Country("DZ", {
    en: "Algeria",
    it: "Algeria",
    de: "Algerien",
    fr: "Algérie",
    es: "Argelia",
  });
  static readonly ANDORRA = new Country("AD", {
    en: "Andorra",
    it: "Andorra",
    de: "Andorra",
    fr: "Andorra",
    es: "Andorra",
  });
  static readonly ANGOLA = new Country("AO", {
    en: "Angola",
    it: "Angola",
    de: "Angola",
    fr: "Angola",
    es: "Angola",
  });
  static readonly ARGENTINA = new Country("AR", {
    en: "Argentina",
    it: "Argentina",
    de: "Argentinien",
    fr: "Argentine",
    es: "Argentina",
  });
  static readonly ARMENIA = new Country("AM", {
    en: "Armenia",
    it: "Armenia",
    de: "Armenien",
    fr: "Arménie",
    es: "Armenia",
  });
  static readonly AUSTRALIA = new Country("AU", {
    en: "Australia",
    it: "Australia",
    de: "Australien",
    fr: "Australie",
    es: "Australia",
  });
  static readonly AUSTRIA = new Country("AT", {
    en: "Austria",
    it: "Austria",
    de: "Österreich",
    fr: "Autriche",
    es: "Austria",
  });
  static readonly AZERBAIJAN = new Country("AZ", {
    en: "Azerbaijan",
    it: "Azerbaijan",
    de: "Azerbaijan",
    fr: "Azerbaïdjan",
    es: "Azerbaiyán",
  });
  static readonly BANGLADESH = new Country("BD", {
    en: "Bangladesh",
    it: "Bangladesh",
    de: "Bangladesh",
    fr: "Bangladesh",
    es: "Bangladesh",
  });
  static readonly BELGIUM = new Country("BE", {
    en: "Belgium",
    it: "Belgio",
    de: "Belgien",
    fr: "Belgique",
    es: "Bélgica",
  });
  static readonly BOTSWANA = new Country("BW", {
    en: "Botswana",
    it: "Botswana",
    de: "Botswana",
    fr: "Botswana",
    es: "Botswana",
  });
  static readonly BRAZIL = new Country("BR", {
    en: "Brazil",
    it: "Brasile",
    de: "Brazil",
    fr: "Brésil",
    es: "Brasil",
  });
  static readonly BULGARIA = new Country("BG", {
    en: "Bulgaria",
    it: "Bulgaria",
    de: "Bulgary",
    fr: "Bulgary",
    es: "Bulgary",
  });
  static readonly CANADA = new Country("CA", {
    en: "Canada",
    it: "Canada",
    de: "Kanada",
    fr: "Canada",
    es: "Canadá",
  });
  static readonly CHILE = new Country("CL", {
    en: "Chile",
    it: "Cile",
    de: "Chile",
    fr: "Chili",
    es: "Chile",
  });
  static readonly CHINA = new Country("CN", {
    en: "China",
    it: "Cina",
    de: "China",
    fr: "Chine",
    es: "China",
  });
  static readonly COLOMBIA = new Country("CO", {
    en: "Colombia",
    it: "Colombia",
    de: "Colombia",
    fr: "Colombie",
    es: "Colombia",
  });
  static readonly COMORE = new Country("KM", {
    en: "Comore",
    it: "Comore",
    de: "Comore",
    fr: "Comore",
    es: "Comore",
  });
  static readonly COSTA_RICA = new Country("CR", {
    en: "Costa Rica",
    it: "Costa Rica",
    de: "Costa Rica",
    fr: "Costa Rica",
    es: "Costa Rica",
  });
  static readonly CROATIA = new Country("HR", {
    en: "Croatia",
    it: "Croazia",
    de: "Croatia",
    fr: "Croatia",
    es: "Croacia",
  });
  static readonly CYPRUS = new Country("CY", {
    en: "Cyprus",
    it: "Cipro",
    de: "Cyprus",
    fr: "Cyprus",
    es: "Chipre",
  });
  static readonly CUBA = new Country("CU", {
    en: "Cuba",
    it: "Cuba",
    de: "Cuba",
    fr: "Cuba",
    es: "Cuba",
  });
  static readonly CZECH_REPUBLIC = new Country("CZ", {
    en: "Czech Republic",
    it: "Repubblica Ceca",
    de: "Czech Republic",
    fr: "Czech Republic",
    es: "República Checa",
  });
  static readonly DENMARK = new Country("DK", {
    en: "Denmark",
    it: "Danimarca",
    de: "Dänemark",
    fr: "Danemark",
    es: "Dinamarca",
  });
  static readonly ECUADOR = new Country("EC", {
    en: "Ecuador",
    it: "Ecuador",
    de: "Ekuador",
    fr: "Équateur",
    es: "Ecuador",
  });
  static readonly EGYPT = new Country("EG", {
    en: "Egypt",
    it: "Egitto",
    de: "Egypt",
    fr: "Égypte",
    es: "Egipto",
  });
  static readonly EL_SALVADOR = new Country("SV", {
    en: "El Salvador",
    it: "El Salvador",
    de: "El Salvador",
    fr: "El Salvador",
    es: "El Salvador",
  });
  static readonly ESTONIA = new Country("EE", {
    en: "Estonia",
    it: "Estonia",
    de: "Estonia",
    fr: "Estonie",
    es: "Estonia",
  });
  static readonly ETHIOPIA = new Country("ET", {
    en: "Ethiopia",
    it: "Etiopia",
    de: "Äthiopien",
    fr: "Éthiopie",
    es: "Etiopía",
  });
  static readonly FIJI = new Country("FJ", {
    en: "Fiji",
    it: "Figi",
    de: "Fidschiinseln",
    fr: "Fiji",
    es: "Islas Fiji",
  });
  static readonly FINLAND = new Country("FI", {
    en: "Finland",
    it: "Finlandia",
    de: "Finnland",
    fr: "Finlande",
    es: "Finlandia",
  });
  static readonly FRANCE = new Country("FR", {
    en: "France",
    it: "Francia",
    de: "Frankreich",
    fr: "France",
    es: "Francia",
  });
  static readonly GERMANY = new Country("DE", {
    en: "Germany",
    it: "Germania",
    de: "Germany",
    fr: "Germany",
    es: "Alemania",
  });
  static readonly GHANA = new Country("GH", {
    en: "Ghana",
    it: "Ghana",
    de: "Ghana",
    fr: "Ghana",
    es: "Ghana",
  });
  static readonly GREECE = new Country("GR", {
    en: "Greece",
    it: "Grecia",
    de: "Griechenland",
    fr: "Grèce",
    es: "Grecia",
  });
  static readonly GUATEMALA = new Country("GT", {
    en: "Guatemala",
    it: "Guatemala",
    de: "Guatemala",
    fr: "Guatémala",
    es: "Guatemala",
  });
  static readonly HUNGARY = new Country("HU", {
    en: "Hungary",
    it: "Ungheria",
    de: "Ungarn",
    fr: "Hongrie",
    es: "Hungría",
  });
  static readonly ICELAND = new Country("IS", {
    en: "Iceland",
    it: "Islanda",
    de: "Island",
    fr: "Islande",
    es: "Islandia",
  });
  static readonly INDIA = new Country("IN", {
    en: "India",
    it: "India",
    de: "Indien",
    fr: "Inde",
    es: "India",
  });
  static readonly INDONESIA = new Country("ID", {
    en: "Indonesia",
    it: "Indonesia",
    de: "Indonesien",
    fr: "Indonésie",
    es: "Indonesia",
  });
  static readonly IRAN = new Country("IR", {
    en: "Iran",
    it: "Iran",
    de: "Iran",
    fr: "Iran",
    es: "Irán",
  });
  static readonly IRELAND = new Country("IE", {
    en: "Ireland",
    it: "Irlanda",
    de: "Irland",
    fr: "Irlande",
    es: "Irlanda",
  });
  static readonly ISRAEL = new Country("IL", {
    en: "Israel",
    it: "Israele",
    de: "Israel",
    fr: "Israël",
    es: "Israel",
  });
  static readonly ITALY = new Country("IT", {
    en: "Italy",
    it: "Italia",
    de: "Italien",
    fr: "Italie",
    es: "Italia",
  });
  static readonly JAPAN = new Country("JP", {
    en: "Japan",
    it: "Giappone",
    de: "Japan",
    fr: "Japan",
    es: "Japón",
  });
  static readonly JORDAN = new Country("JO", {
    en: "Jordan",
    it: "Giordania",
    de: "Jordan",
    fr: "Jordan",
    es: "Jordania",
  });
  static readonly KENYA = new Country("KE", {
    en: "Kenya",
    it: "Kenia",
    de: "Kenya",
    fr: "Kenya",
    es: "Kenia",
  });
  static readonly LEBANON = new Country("LB", {
    en: "Lebanon",
    it: "Libano",
    de: "Lebanon",
    fr: "Lebanon",
    es: "Líbano",
  });
  static readonly LITHUANIA = new Country("LT", {
    en: "Lithuania",
    it: "Lituania",
    de: "Lithuania",
    fr: "Lithuania",
    es: "Lituania",
  });
  static readonly LUXEMBOURG = new Country("LU", {
    en: "Luxembourg",
    it: "Lussemburgo",
    de: "Luxemburg",
    fr: "Luxembourg",
    es: "Luxemburgo",
  });
  static readonly MACEDONIA = new Country("MK", {
    en: "Macedonia",
    it: "Macedonia",
    de: "Makedonien",
    fr: "Macédoine",
    es: "Macedonia",
  });
  static readonly MALAYSIA = new Country("MY", {
    en: "Malaysia",
    it: "Malaysia",
    de: "Malaysia",
    fr: "Malaisie",
    es: "Malaisia",
  });
  static readonly MALTA = new Country("MT", {
    en: "Malta",
    it: "Malta",
    de: "Malta",
    fr: "Malte",
    es: "Malta",
  });
  static readonly MEXICO = new Country("MX", {
    en: "Mexico",
    it: "Messico",
    de: "Mexiko",
    fr: "Mexique",
    es: "México",
  });
  static readonly MOROCCO = new Country("MO", {
    en: "Morocco",
    it: "Marocco",
    de: "Marokko",
    fr: "Maroc",
    es: "Marruecos",
  });
  static readonly NEW_ZEALAND = new Country("NZ", {
    en: "New Zealand",
    it: "Nuova Zelanda",
    de: "Neuseeland",
    fr: "Nouvelle-Zélande",
    es: "Nueva Zelandia",
  });
  static readonly NORWAY = new Country("NO", {
    en: "Norway",
    it: "Norvegia",
    de: "Norwegen",
    fr: "Norvège",
    es: "Noruega",
  });
  static readonly PANAMA = new Country("PA", {
    en: "Panama",
    it: "Panama",
    de: "Panama",
    fr: "Panama",
    es: "Panamá",
  });
  static readonly PARAGUAY = new Country("PY", {
    en: "Paraguay",
    it: "Paraguay",
    de: "Paraguay",
    fr: "Paraguay",
    es: "Paraguay",
  });
  static readonly PERÙ = new Country("PE", {
    en: "Perù",
    it: "Perù",
    de: "Perù",
    fr: "Perù",
    es: "Perù",
  });
  static readonly POLAND = new Country("PL", {
    en: "Poland",
    it: "Polonia",
    de: "Polen",
    fr: "Pologne",
    es: "Polonia",
  });
  static readonly PORTUGAL = new Country("PT", {
    en: "Portugal",
    it: "Portogallo",
    de: "Portugal",
    fr: "Portugal",
    es: "Portugal",
  });
  static readonly ROMANIA = new Country("RO", {
    en: "Romania",
    it: "Romania",
    de: "Rumänien",
    fr: "Roumanie",
    es: "Rumania",
  });
  static readonly RUSSIA = new Country("RU", {
    en: "Russia",
    it: "Russia",
    de: "Russland",
    fr: "Russie",
    es: "Rusia",
  });
  static readonly SINGAPORE = new Country("SG", {
    en: "Singapore",
    it: "Singapore",
    de: "Singapur",
    fr: "Singapour",
    es: "Singapur",
  });
  static readonly SLOVAKIA = new Country("SK", {
    en: "Slovakia",
    it: "Slovacchia",
    de: "Slowakei",
    fr: "Slovaquie",
    es: "Eslovaquia",
  });
  static readonly SLOVENIA = new Country("SI", {
    en: "Slovenia",
    it: "Slovenia",
    de: "Slowenien",
    fr: "Slovénie",
    es: "Eslovenia",
  });
  static readonly SOUTH_AFRICA = new Country("ZA", {
    en: "South Africa",
    it: "Sud Africa",
    de: "Südafrika",
    fr: "Afrique du Sud",
    es: "Sudáfrica",
  });
  static readonly SPAIN = new Country("ES", {
    en: "Spain",
    it: "Spagna",
    de: "Spanien",
    fr: "Espagne",
    es: "España",
  });
  static readonly SWEDEN = new Country("SE", {
    en: "Sweden",
    it: "Svezia",
    de: "Schweden",
    fr: "Suède",
    es: "Suecia",
  });
  static readonly SWITZERLAND = new Country("CH", {
    en: "Switzerland",
    it: "Svizzera",
    de: "Schweiz",
    fr: "Suisse",
    es: "Suiza",
  });
  static readonly TAIWAN = new Country("TW", {
    en: "Taiwan",
    it: "Taiwan",
    de: "Taiwan",
    fr: "Taiwan",
    es: "Taiwán",
  });
  static readonly TANZANIA = new Country("TZ", {
    en: "Tanzania",
    it: "Tanzania",
    de: "Tanzania",
    fr: "Tanzanie",
    es: "Tanzania",
  });
  static readonly THAILAND = new Country("TH", {
    en: "Thailand",
    it: "Tailandia",
    de: "Thailand",
    fr: "Thaïlande",
    es: "Tailandia",
  });
  static readonly TURKEY = new Country("TR", {
    en: "Turkey",
    it: "Turchia",
    de: "Turkey",
    fr: "Turquie",
    es: "Turquía",
  });
  static readonly UNITED_KINGDOM = new Country("GB", {
    en: "United Kingdom",
    it: "Inghilterra",
    de: "England",
    fr: "Angleterre",
    es: "Inglaterra",
  });
  static readonly SAUDI_ARABIA = new Country("SA", {
    en: "Saudi Arabia",
    it: "Arabia Saudita",
    de: "Saudi-Arabien",
    fr: "Arabie Saoudite",
    es: "Arabia Saudita",
  });
  static readonly USA = new Country("US", {
    en: "United States of America",
    it: "Stati Uniti d'America",
    de: "USA",
    fr: "USA",
    es: "Estados Unidos de América",
  });
  static readonly VENEZUELA = new Country("VE", {
    en: "Venezuela",
    it: "Venezuela",
    de: "Venezuela",
    fr: "Venezuela",
    es: "Venezuela",
  });
  static readonly VIETNAM = new Country("VN", {
    en: "Vietnam",
    it: "Vietnam",
    de: "Vietnam",
    fr: "Vietnam",
    es: "Vietnam",
  });
  static readonly YEMEN = new Country("YE", {
    en: "Yemen",
    it: "Yemen",
    de: "Yemen",
    fr: "Yémen",
    es: "Yemen",
  });
  static readonly SAN_MARINO = new Country("SM", {
    en: "San Marino",
    it: "Repubblica di San Marino",
    de: "San Marino",
    fr: "Saint-Marin",
    es: "República of San Marino",
  });
  static readonly SENEGAL = new Country("SN", {
    en: "Senegal",
    it: "Senegal",
    de: "Senegal",
    fr: "Sénégal",
    es: "Senegal",
  });
  static readonly SOUTH_KOREA = new Country("KR", {
    en: "South Korea",
    it: "Corea del Sud",
    de: "Corea del Sud",
    fr: "Corée du Sud",
    es: "Corea del Sur",
  });
  static readonly HOLLAND = new Country("NL", {
    en: "Holland",
    it: "Olanda",
    de: "Holland",
    fr: "Hollande",
    es: "Holanda",
  });
  static readonly UNITED_ARAB_EMIRATES = new Country("AE", {
    en: "United Arab Emirates",
    it: "Emirati Arabi Uniti",
    de: "Emirates",
    fr: "Emirates",
    es: "Emirates",
  });
  static readonly LIBIA = new Country("LY", {
    en: "Libia",
    it: "Libia",
    de: "Libia",
    fr: "Libia",
    es: "Libia",
  });
  static readonly BOLIVIA = new Country("BO", {
    en: "Bolivia",
    it: "Bolivia",
    de: "Bolivia",
    fr: "Bolivia",
    es: "Bolivia",
  });
  static readonly COTE_D_IVOIRE = new Country("CI", {
    en: "Cote d'Ivoire",
    it: "Costa d'avorio",
    de: "Cote d'Ivoire",
    fr: "Cote d'Ivoire",
    es: "Cote d'Ivoire",
  });
  static readonly UKRAINE = new Country("UA", {
    en: "Ukraine",
    it: "Ucraina",
    de: "Ukraine",
    fr: "Ukraine",
    es: "Ucrania",
  });
  static readonly BAHRAIN = new Country("BH", {
    en: "Bahrain",
    it: "Bahrain",
    de: "Bahrain",
    fr: "Bahrain",
    es: "Bahrain",
  });
  static readonly SERBIA_MONTENEGRO = new Country("ME", {
    en: "Serbia Montenegro",
    it: "Serbia Montenegro",
    de: "Serbia Montenegro",
    fr: "Serbia Montenegro",
    es: "Serbia Montenegro",
  });
  static readonly LIECHTENSTEIN = new Country("LI", {
    en: "Liechtenstein",
    it: "Liechtenstein",
    de: "Liechtenstein",
    fr: "Liechtenstein",
    es: "Liechtenstein",
  });
  static readonly LETTONIA = new Country("LV", {
    en: "Lettonia",
    it: "Lettonia",
    de: "Lettonia",
    fr: "Lettonia",
    es: "Lettonia",
  });
  static readonly QATAR = new Country("QA", {
    en: "Qatar",
    it: "Qatar",
    de: "Qatar",
    fr: "Qatar",
    es: "Qatar",
  });
  static readonly PAKISTAN = new Country("PK", {
    en: "Pakistan",
    it: "Pakistan",
    de: "Pakistan",
    fr: "Pakistan",
    es: "Pakistan",
  });
  static readonly PRINCIPATO_DI_MONACO = new Country("MC", {
    en: "Principato di Monaco",
    it: "Principato di Monaco",
    de: "Principato di Monaco",
    fr: "Principato di Monaco",
    es: "Principato di Monaco",
  });
  static readonly GEORGIA = new Country("GE", {
    en: "Georgia",
    it: "Georgia",
    de: "Georgia",
    fr: "Georgia",
    es: "Georgia",
  });
  static readonly KAZAKISTAN = new Country("KZ", {
    en: "Kazakistan",
    it: "Kazakistan",
    de: "Kazakistan",
    fr: "Kazakistan",
    es: "Kazakistan",
  });
  static readonly NIGERIA = new Country("NG", {
    en: "Nigeria",
    it: "Nigeria",
    de: "Nigeria",
    fr: "Nigeria",
    es: "Nigeria",
  });
  static readonly SRI_LANKA = new Country("LK", {
    en: "Sri Lanka",
    it: "Sri Lanka",
    de: "Sri Lanka",
    fr: "Sri Lanka",
    es: "Sri Lanka",
  });
  static readonly TUNISIE = new Country("TN", {
    en: "Tunisie",
    it: "Tunisia",
    de: "Tunisie",
    fr: "Tunisie",
    es: "Tunisia",
  });
  static readonly URUGUAY = new Country("UY", {
    en: "Uruguay",
    it: "Uruguay",
    de: "Uruguay",
    fr: "Uruguay",
    es: "Uruguay",
  });
  static readonly SYRIA = new Country("SY", {
    en: "Syria",
    it: "Siria",
    de: "Syrien",
    fr: "Syrie",
    es: "Siria",
  });
  static readonly UZBEKISTAN = new Country("UZ", {
    en: "Uzbekistan",
    it: "Uzbekistan",
    de: "Uzbekistan",
    fr: "Uzbekistan",
    es: "Uzbekistan",
  });

  private constructor(
    public readonly code: string,
    public readonly labels: {
      en: string;
      it: string;
      de: string;
      fr: string;
      es: string;
    },
  ) {}

  static getAll(): Country[] {
    return [
      this.ALBANIA,
      this.ALGERIA,
      this.ANDORRA,
      this.ANGOLA,
      this.ARGENTINA,
      this.ARMENIA,
      this.AUSTRALIA,
      this.AUSTRIA,
      this.AZERBAIJAN,
      this.BANGLADESH,
      this.BELGIUM,
      this.BOTSWANA,
      this.BRAZIL,
      this.BULGARIA,
      this.CANADA,
      this.CHILE,
      this.CHINA,
      this.COLOMBIA,
      this.COMORE,
      this.COSTA_RICA,
      this.CROATIA,
      this.CYPRUS,
      this.CUBA,
      this.CZECH_REPUBLIC,
      this.DENMARK,
      this.ECUADOR,
      this.EGYPT,
      this.EL_SALVADOR,
      this.ESTONIA,
      this.ETHIOPIA,
      this.FIJI,
      this.FINLAND,
      this.FRANCE,
      this.GERMANY,
      this.GHANA,
      this.GREECE,
      this.GUATEMALA,
      this.HUNGARY,
      this.ICELAND,
      this.INDIA,
      this.INDONESIA,
      this.IRAN,
      this.IRELAND,
      this.ISRAEL,
      this.ITALY,
      this.JAPAN,
      this.JORDAN,
      this.KENYA,
      this.LEBANON,
      this.LITHUANIA,
      this.LUXEMBOURG,
      this.MACEDONIA,
      this.MALAYSIA,
      this.MALTA,
      this.MEXICO,
      this.MOROCCO,
      this.NEW_ZEALAND,
      this.NORWAY,
      this.PANAMA,
      this.PARAGUAY,
      this.PERÙ,
      this.POLAND,
      this.PORTUGAL,
      this.ROMANIA,
      this.RUSSIA,
      this.SINGAPORE,
      this.SLOVAKIA,
      this.SLOVENIA,
      this.SOUTH_AFRICA,
      this.SPAIN,
      this.SWEDEN,
      this.SWITZERLAND,
      this.TAIWAN,
      this.TANZANIA,
      this.THAILAND,
      this.TURKEY,
      this.UNITED_KINGDOM,
      this.SAUDI_ARABIA,
      this.USA,
      this.VENEZUELA,
      this.VIETNAM,
      this.YEMEN,
      this.SAN_MARINO,
      this.SENEGAL,
      this.SOUTH_KOREA,
      this.HOLLAND,
      this.UNITED_ARAB_EMIRATES,
      this.LIBIA,
      this.BOLIVIA,
      this.COTE_D_IVOIRE,
      this.UKRAINE,
      this.BAHRAIN,
      this.SERBIA_MONTENEGRO,
      this.LIECHTENSTEIN,
      this.LETTONIA,
      this.QATAR,
      this.PAKISTAN,
      this.PRINCIPATO_DI_MONACO,
      this.GEORGIA,
      this.KAZAKISTAN,
      this.NIGERIA,
      this.SRI_LANKA,
      this.TUNISIE,
      this.URUGUAY,
      this.SYRIA,
      this.UZBEKISTAN,
    ];
  }

  static getSelectOptions(locale: ISupportedLanguage): Array<{
    value: string;
    label: string;
  }> {
    return this.getAll().map((country) => ({
      value: country.code,
      label: country.labels[locale],
    }));
  }

  static getByCode(code: string): Country | undefined {
    return this.getAll().find((country) => country.code === code);
  }
}
